import morph from "../../helpers/morph";
import "./product-card-swatches";

class ProductCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("change", (e) => {
      this._changeContent(e.target.value);
    });
  }

  disconnectedCallback() {}

  _changeContent(id) {
    this._loadData().then((data) => {
      const productData = data.find(({ variant_id }) => variant_id === id);

      if (!productData) {
        console.warn(`No product card data found for ${id}`);
        return;
      }

      const html = new DOMParser().parseFromString(
        productData.markup,
        "text/html",
      );

      const newProductCardMarkup = html.querySelector("product-card");

      morph(this, newProductCardMarkup);
    });
  }

  _loadData() {
    if (this.data) return Promise.resolve(this.data);
    if (this.loadingData) return this.loadingData;
    const url = new URL(`${window.location.origin}${this.productUrl}`);

    url.searchParams.set("section_id", "product-card-content");
    this.loadingData = fetch(url)
      .then((res) => res.text())
      .then((markup) => {
        const html = new DOMParser().parseFromString(markup, "text/html");
        this.data = JSON.parse(html.querySelector("script").innerHTML);
        return this.data;
      });

    return this.loadingData;
  }

  get productUrl() {
    return this.getAttribute("product-url");
  }
}

if (!customElements.get("product-card")) {
  customElements.define("product-card", ProductCard);
}
